<template>
  <div>
    <div>
      <div
        class="flex items-center justify-center p-5 text-center bg-white rounded "
      >
        <div class="text-2xl font-bold">{{ $t('market.summary_report') }}</div>
      </div>
      <div class="grid grid-cols-5 gap-2 py-3">
        <div>
          <!-- button rounded  -->
          <router-link class="router-class" to="checkout">
            {{ $t('customer.seller_checkout') }}
          </router-link>
        </div>
        <div>
          <router-link class="router-class" to="checkin">
            {{ $t('customer.customer_move_in') }}
          </router-link>
        </div>
        <div>
          <router-link class="router-class" to="active">
            {{ $t('customer.current_customer') }}
          </router-link>
        </div>
        <div>
          <router-link class="router-class" to="cashback">
            {{ $t('payment.deposit_refund_list') }}
          </router-link>
        </div>
        <div>
          <router-link class="router-class" to="invoice">
            {{ $t('payment.unpaid_payment_list') }}
          </router-link>
        </div>
        <div>
          <router-link class="router-class" to="booking-daily">
            {{ $t('booking.booking_daily') }}
          </router-link>
        </div>
        <div>
          <router-link class="router-class" to="booking-monthly">
            {{ $t('booking.booking_monthly') }}
          </router-link>
        </div>
        <div>
           <router-link class="router-class" to="appeal">
            {{ $t('appeal.appeal_list') }}
          </router-link>
        </div>
        <div>
          <router-link class="router-class" to="contract-suspend">
            {{ $t('suspend.contract_suspend_list') }}
          </router-link>
        </div>
        <div>
          <router-link class="router-class" to="contract-will-expired">
            {{ $t('contract.contract_will_expired_list') }}
          </router-link>
        </div>
        <div>
          <router-link class="router-class" to="auditlog">
            {{ $t('area.edit_log') }}
          </router-link>
        </div>
        <div>
          <router-link class="router-class" to="meter-digital-elec">
            {{ $t('meter.digital_electricity_meter') }}
          </router-link>
        </div>
        <div></div>
      </div>
    </div>
    <div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {},
};
</script>

<style scoped>
.router-link-exact-active {
  @apply text-screamin-green-700 !important;
}
.router-class {
  @apply bg-white block w-full p-3 text-center text-black transition-all  rounded hover:text-screamin-green-700 hover:scale-110;
}
</style>